import React from 'react';
import { connect } from 'react-redux';
import { Select } from 'antd';
import { getProjectZoneId } from '../reducers/analyticsApp';
import { setUserZoneId as setUserZoneIdAction } from '../actions/project';
import TIME_ZONES from '../constants/timeZones';

const ZoneSelect = ({ timezone, setUserZoneId }) => (
  <Select style={{ width: 200 }} value={timezone} onChange={setUserZoneId}>
    {Object.keys(TIME_ZONES).map((zoneId, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Select.Option key={index} value={zoneId}>
        {zoneId}
      </Select.Option>
    ))}
  </Select>
);

const mapStateToProps = (state) => ({
  timezone: getProjectZoneId(state),
});

const mapDispatchToProps = {
  setUserZoneId: setUserZoneIdAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoneSelect);
